import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { Documento } from '../_model/documento';
import { DocumentoService } from '../_service/documento.service';

@Injectable({ providedIn: 'root' })
export class DocumentosResolver implements Resolve<Observable<Documento[]>>{

    constructor(private service: DocumentoService) { }

    resolve(route: ActivatedRouteSnapshot): Observable<Documento[]> {
        const codes = ['PoliticaPrivacidade', 'CodigoEtica', 'PoliticaSegurancaCibernetica'];
        return this.service.getDocumentos(codes);
    }
}
